import { render, staticRenderFns } from "./general-reviews.vue?vue&type=template&id=01aaec57&scoped=true&"
import script from "./general-reviews.vue?vue&type=script&lang=js&"
export * from "./general-reviews.vue?vue&type=script&lang=js&"
import style0 from "./general-reviews.vue?vue&type=style&index=0&id=01aaec57&scoped=true&lang=css&"
import style1 from "./general-reviews.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01aaec57",
  null
  
)

export default component.exports